import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableValue } from '../interfaces.js';
import { KnowEdmTableData } from './table-enums.js';

const projectDataMap = new Map<KnowEdmTableData, KnowEdmTableValue<KnowEdmTableData>>();

projectDataMap.set(KnowEdmTableData.WellConfiguration, {
  key: KnowEdmTableData.WellConfiguration,
  unit: '',
  label: 'Well Configuration',
  quantity: '',
  tooltip: 'entities_wellConfigurationTooltip',
});

projectDataMap.set(KnowEdmTableData.DrillingUnit, {
  key: KnowEdmTableData.DrillingUnit,
  unit: '',
  label: 'Drilling Unit',
  quantity: '',
  tooltip: 'entities_drillingUnitTooltip',
});

projectDataMap.set(KnowEdmTableData.WaterDepth, {
  key: KnowEdmTableData.WaterDepth,
  label: 'Water Depth',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  tooltip: 'entities_waterDepthTooltip',
});

projectDataMap.set(KnowEdmTableData.DrillFloorHeightAirgap, {
  key: KnowEdmTableData.DrillFloorHeightAirgap,
  label: 'Drill Floor Height / Airgap',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  tooltip: 'entities_drillFloorHeightTooltip',
});

projectDataMap.set(KnowEdmTableData.WellheadDepth, {
  key: KnowEdmTableData.WellheadDepth,
  label: 'Wellhead Depth',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  tooltip: 'entities_wellheadDepthTooltip',
});

projectDataMap.set(KnowEdmTableData.WellStatus, {
  key: KnowEdmTableData.WellStatus,
  unit: '',
  label: 'Well Status',
  quantity: '',
  tooltip: 'entities_wellStatusTooltip',
});

projectDataMap.set(KnowEdmTableData.GroundElevation, {
  key: KnowEdmTableData.GroundElevation,
  label: 'Ground elevation',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  tooltip: 'entities_groundElevationTooltip',
});

export { projectDataMap };
